module.exports = __webpack_public_path__ + "static/img/letbane-logo.c015cb3b.svg";